import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { IMapyBoxItem } from "~/interfaces";
import { node } from "~/util/dom";

interface ISharing {
	data?: IMapyBoxItem;
}

export function createMyMapsSharing({
	data,
}: ISharing) {
	const container = node("div", { className: "mymaps-sharing" });
	const image = new Image();

	image.classList.add("mymaps-sharing__avatar");
	image.src = data.owner_avatar;

	if (CONFIG.wasmEnabled) {
		image.crossOrigin = "anonymous";
	}

	const author = node("span", { className: "mymaps-sharing__author", textContent: `${_("detail.content.mymapsplace.author")} ${data.owner_name}` });

	container.append(image, author);

	return container;
}
